import { Command } from '@nextforce/api'
import { t } from 'app/i18l'
import { NonAvailabilityRequestScreenProps } from 'home/stack/types'
import { useNonAvailability } from 'non_availability/queries/list'
import { usePerformNonAvailabilityAction } from 'non_availability/queries/perform_action'
import { StoreUserNonAvailability } from 'non_availability/queries/types'
import {
  buildNonAvailabilityMutationAction,
  mapNonAvailabilityToCells,
} from 'non_availability/utils'
import { useCallback, useLayoutEffect, useMemo } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { NonAvailabilityRequestView } from './view'

export function NonAvailabilityRequestScreen({
  navigation,
  route,
}: NonAvailabilityRequestScreenProps) {
  const nonAvailabilityQuery = useNonAvailability({
    requestId: route.params?.id,
  })

  const store = nonAvailabilityQuery.data?.store

  const cells = useMemo(() => {
    return mapNonAvailabilityToCells(nonAvailabilityQuery.data?.nonAvailability)
  }, [nonAvailabilityQuery.data?.nonAvailability])

  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('availabilityChangeRequest'))
  }, [navigation])

  const nonAvailabilityMutation = usePerformNonAvailabilityAction()

  const onCommandButtonPress = useCallback(
    async (command: Command, nonAvailability: StoreUserNonAvailability) => {
      if (command.type === 'action') {
        try {
          const mutationAction = buildNonAvailabilityMutationAction(
            nonAvailability,
            command.action
          )
          await nonAvailabilityMutation.mutateAsync(mutationAction)
        } catch (err: any) {
          errorAlert(
            err,
            t('couldNotApproveRejectAvailabilityRequestErrorTitle')
          )
          console.log(err)
        }
      }
    },
    [nonAvailabilityMutation]
  )

  return (
    <StatusBoundary
      isLoading={nonAvailabilityQuery.isLoading}
      error={nonAvailabilityQuery.error}
    >
      <NonAvailabilityRequestView
        store={store}
        cells={cells}
        nonAvailability={nonAvailabilityQuery.data}
        onCommandButtonPress={onCommandButtonPress}
      />
    </StatusBoundary>
  )
}
